import { post } from './apiFunctions';

const URL = '/medl/event_create.php';

export class Events {
    constructor(form, kamp, blockCode) {
        this.form = form;
        this.kamp = kamp;
        this.blockCode = blockCode;
    }

    eventObject(event, action, value, error) {
        return {
            path: this.form,
            form: this.blockCode,
            kamp: this.kamp,
            event,
            action,
            value,
            error,
            cookies: navigator.cookieEnabled
        };
    }

    startEvent() {
        post(URL, this.eventObject(this.form, 'sidevisning'));
    }

    changeEvent(input) {
        post(URL, this.eventObject('change', input));
    }

    ignoreLoginEvent() {
        post(URL, this.eventObject('ignore-login', 'ignore'));
    }

    phoneLookUpEvent(result) {
        post(URL, this.eventObject('phone-lookup', 'phone', result));
    }

    updateStepEvent(step) {
        post(URL, this.eventObject('step', step));
    }
}

export const formName = {
    teddy: `bamse`,
    diplom: `diplom`,
    gift: `gave2`,
    supportus: `giver2`,
    eventgift: `gratulasjon`,
    firstaid: `hjelpepakke`,
    book: `jubileumsbok`,
    calender: `kjopkalender`,
    login: `login`,
    memorial: `minnegave`,
    mypage: `profil`,
    will: `testament`,
    helicopter: `helikopter`,
    carpack: 'bilpakke',
    symbolic: 'symbolskgave',
    blanket: 'varmeteppe'
};
